import React, { ComponentType, ReactElement } from 'react'

import Fade from '@material-ui/core/Fade'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'

import smileyIconUrl from 'assets/images/icon-sad.svg'

interface Props<T> {
  isLoading?: boolean
  errorCode?: string
  component: ComponentType<T>
  componentProps: T
}

const styles = (theme: Theme) => createStyles({
  loaderContainer: {
    paddingTop: theme.spacing() * 6,
    paddingBottom: theme.spacing() * 6,
  },
  errorContainer: {
    paddingTop: theme.spacing() * 6,
    paddingBottom: theme.spacing() * 6,
  },
  smileyIcon: {
    width: 128,
    height: 128,
    display: 'block',
    margin: '0 auto',
    paddingBottom: theme.spacing() * 3,
  },
})

type InjectedProps<T> = Props<T> & WithStyles<typeof styles>
type IGFC = <T>(props: InjectedProps<T>) => ReactElement<InjectedProps<T>>

const ActionContext: IGFC = ({
  classes,
  isLoading,
  errorCode,
  component: Component,
  componentProps,
}) => (
    <Fade in key={Number(isLoading) + Number(errorCode) * 2} timeout={{ enter: 500 }}>
      <div>
        {isLoading && (
          <Grid container justify="center" className={classes.loaderContainer}>
            <Grid item>
              <CircularProgress size={50} thickness={7} />
            </Grid>
          </Grid>
        )}
        {!isLoading && errorCode && (
          <div className={classes.errorContainer}>
            <img alt="" src={smileyIconUrl} className={classes.smileyIcon} />
            <Typography align="center" variant="h5">Oops, something went wrong!</Typography>
            <Typography align="center" variant="subtitle1" color="textSecondary">{(errorCode as any).message || errorCode}</Typography>
          </div>
        )}
        {!isLoading && !errorCode && <Component {...componentProps} />}
      </div>
    </Fade>
  )

type GFC = <T extends {}>(props: Props<T>) => ReactElement<Props<T>>

export default (withStyles(styles)(ActionContext) as GFC)
try {
    // @ts-ignore
    ActionContext.displayName = "ActionContext";
    // @ts-ignore
    ActionContext.__docgenInfo = { "description": "", "displayName": "ActionContext", "props": { "isLoading": { "defaultValue": null, "description": "", "name": "isLoading", "required": false, "type": { "name": "boolean" } }, "errorCode": { "defaultValue": null, "description": "", "name": "errorCode", "required": false, "type": { "name": "string" } }, "component": { "defaultValue": null, "description": "", "name": "component", "required": true, "type": { "name": "ComponentType<T>" } }, "componentProps": { "defaultValue": null, "description": "", "name": "componentProps", "required": true, "type": { "name": "T" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/ActionContext/ActionContext.tsx#ActionContext"] = { docgenInfo: ActionContext.__docgenInfo, name: "ActionContext", path: "src/components/ActionContext/ActionContext.tsx#ActionContext" };
}
catch (__react_docgen_typescript_loader_error) { }